import SegmentGenerator from "@/components/segment-generator";
import Head from "next/head";
import Layout from "@/components/layout";
import ratingSchema from "@/components/rating-schema-jsonld";

export default function FeaturePage({ pageContent, preview }) {
  return (
    <Layout preview={preview}>
      <Head>
        <title>{pageContent.title}</title>
        <meta name="description" content={pageContent.metaDescription} />
        <meta property="og:title" content={pageContent.title} />
        <meta property="og:description" content={pageContent.metaDescription} />
        <meta
          property="og:url"
          content={`${process.env.NEXT_PUBLIC_HOST}/${pageContent.slug.current}`}
        />
        <meta property="og:type" content="article" />
        <meta
          property="article:modified_time"
          content={pageContent._updatedAt}
        ></meta>
        <meta property="og:site_name" content="JustShip" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content={pageContent.title}></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:label1" content="Est. reading time" />
        <meta name="twitter:data1" content="3 minutes" />
        {ratingSchema()}
      </Head>
      <div className="bg-background-dark-gray">
        {pageContent.segments?.map((segment) => (
          <SegmentGenerator key={segment._id} segment={segment} />
        ))}
      </div>
    </Layout>
  );
}
